import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "cart-menu-line" };
const _hoisted_2 = { class: "flex justify-between items-start gap-2" };
const _hoisted_3 = { class: "flex-1 min-w-0" };
const _hoisted_4 = { class: "font-semibold text-gray-900 truncate" };
const _hoisted_5 = { class: "text-sm text-gray-600 mt-1" };
const _hoisted_6 = { class: "font-semibold text-gray-900 whitespace-nowrap" };
const _hoisted_7 = {
    key: 0,
    class: "mt-2 pl-3 border-l-2 border-gray-200 space-y-1"
};
const _hoisted_8 = {
    key: 0,
    class: "text-gray-500"
};
import { ref, computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CartMenuLine',
    props: {
        item: {}
    },
    setup(__props) {
        const props = __props;
        const expanded = ref(false);
        const lineTotalCent = computed(() => props.item.totalPriceCent ?? Math.round(props.item.totalPrice * 100));
        const formatPrice = (cent) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cent / 100);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, " Menü: " + _toDisplayString(_ctx.item.menuItem.name), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.item.quantity) + "× " + _toDisplayString(formatPrice(_ctx.item.menuItem.priceCent)), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(formatPrice(lineTotalCent.value)), 1 /* TEXT */)
                ]),
                (expanded.value && _ctx.item.componentConfigs?.length)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.componentConfigs, (comp, idx) => {
                            return (_openBlock(), _createElementBlock("li", {
                                key: `${comp.productId}-${idx}`,
                                class: "text-sm text-gray-600"
                            }, [
                                _createTextVNode(_toDisplayString(comp.productName || 'Komponente') + " ", 1 /* TEXT */),
                                (comp.selectedSize)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, " · " + _toDisplayString(comp.selectedSize.name), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true)
                            ]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]))
                    : _createCommentVNode("v-if", true),
                (_ctx.item.componentConfigs?.length)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "text-xs text-primary mt-1",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (expanded.value = !expanded.value), ["stop"]))
                    }, _toDisplayString(expanded.value ? 'Komponenten ausblenden' : 'Komponenten anzeigen'), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
